module.exports = "<app-finance-menu></app-finance-menu>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/finance.component.html
// module id = ./src/app/finance/finance.component.html
// module chunks = main